import { io } from 'socket.io-client';

// Derive socket URL from API URL (remove /api suffix)
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const SOCKET_URL = API_URL.replace('/api', '');

let socket = null;

export const connectSocket = (token) => {
  if (socket?.connected) return socket;

  socket = io(SOCKET_URL, {
    auth: { token }
  });

  socket.on('connect', () => {
    console.log('Socket connected');
  });

  socket.on('disconnect', () => {
    console.log('Socket disconnected');
  });

  socket.on('connect_error', (error) => {
    console.error('Socket connection error:', error.message);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const trackOrder = (orderId) => {
  if (socket?.connected) {
    socket.emit('track:order', orderId);
  }
};

export const untrackOrder = (orderId) => {
  if (socket?.connected) {
    socket.emit('untrack:order', orderId);
  }
};

export const onOrderStatus = (callback) => {
  if (socket) {
    socket.on('order:status', callback);
  }
};

export const onRiderLocation = (callback) => {
  if (socket) {
    socket.on('rider:location:update', callback);
  }
};

export const onRiderNearby = (callback) => {
  if (socket) {
    socket.on('rider:nearby', callback);
  }
};

export const getSocket = () => socket;
